import { formatTimeRangeUnified } from '~/shared/helpers/date'

export const getTimeRange = ({
  startTimeMs,
  endTimeMs,
}: {
  startTimeMs?: number
  endTimeMs?: number
}): string => {
  if (!startTimeMs || !endTimeMs) return ''

  return formatTimeRangeUnified(startTimeMs, endTimeMs)
}

export const getProgramTitle = ({
  programTitle,
  startTimeMs,
  endTimeMs,
}: {
  programTitle?: string
  startTimeMs?: number
  endTimeMs?: number
}): string => {
  if (!programTitle || !startTimeMs || !endTimeMs) return ''

  const time = getTimeRange({ startTimeMs, endTimeMs })

  return `${programTitle} • ${time}`
}
